export const themes = {
  light: {
    background: "var(--light-gray)",
    colorListBg: "var(--light-gray)",
    colorListText: "var(--light-dark-grayish-blue)",
    colorTextLight: "var(--light-dark-grayish-blue)",
    colorTextCompleted: "var(--light-light-grayish-blue)",
    colorInput: "var(--light-very-dark-grayish-blue)",
    colorPlaceholder: "var(--light-dark-grayish-blue)",
    colorPath: "var(--light-very-dark-grayish-blue)",
    colorBtn: "var(--light-dark-grayish-blue)",
    colorBtnHover: "var(--light-very-dark-grayish-blue)",
    colorBtnActive: "var(--bright-blue)",
    border: "1px solid var(--light-light-grayish-blue)",
    shadow: "0px 35px 50px #C2C3D680",
  },
  dark: {
    background: "var(--dark-blue)",
    colorListBg: "var(--dark-desaturated-blue)",
    colorListText: "var(--dark-grayish-blue)",
    colorTextLight: "var(--dark-very-dark-grayish-blue)",
    colorTextCompleted: "var(--dark-very-dark-grayish-blue)",
    colorInput: "var(--dark-very-dark-grayish-blue)",
    colorPlaceholder: "var(--light-dark-grayish-blue)",
    colorPath: "var(--dark-grayish-blue-hover)",
    colorBtn: "var(--dark-dark-grayish-blue)",
    colorBtnHover: "var(--dark-grayish-blue-hover)",
    colorBtnActive: "var(--bright-blue)",
    border: "1px solid var(--dark-very-dark-grayish-blue-border)",
    shadow: "0px 35px 50px #00000080",
  },
};
